import styled from "styled-components";

export const LandingPageContainer = styled.div`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 96px;
    padding: 48px;
    width: 100%;

    @media (max-width: 768px) {
        padding: 24px;
    }
`;

export const LandingContent = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 32px;
    justify-content: center;
    text-align: center;
    width: 100%;

    h1 {
        color: #FFFFFF;
        font-family: 'Inter', sans-serif;
        font-size: 48px;
        font-weight: 700;

        @media (max-width: 768px) {
            font-size: 36px;
        }

        @media (max-width: 480px) {
            font-size: 28px;
        }
    }

    p {
        color: rgba(255, 255, 255, 0.5);
        font-size: 18px;
        line-height: 1.6;
        margin: 0;

        @media (max-width: 768px) {
            font-size: 16px;
        }
    }
`;

export const Hero = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const CTAButtons = styled.div`
    display: flex;
    gap: 12px;
    margin-bottom: 24px;

    @media (max-width: 1024px) {
        margin-bottom: 16px;
    }
`;

export const DiscordBtn = styled.button`
    align-items: center;
    background: #5865F2;
    border: 1px solid rgba(88, 101, 242, 0.6);
    border-radius: 4px;
    box-sizing: border-box;
    color: #FFFFFF;
    cursor: pointer;
    display: flex;
    font-size: 12px;
    font-weight: 600;
    gap: 12px;
    height: 40px;
    min-width: 160px;
    padding: 0px 16px;
    transition: 0.3s ease-in-out;

    img {
        height: 20px;
    }

    &:hover {
        background: #4752C4;
        transform: scale(0.985);
    }
`;

export const MainGradientBGContainer = styled.div`
    height: 100vh;
    position: fixed;
    width: 100vw;
    top: 0;
    z-index: -500;
`;
